import { FunctionComponent, HTMLAttributes } from 'react';
import styled from 'styled-components';

interface PlayerProps extends HTMLAttributes<HTMLDivElement> {}

const UnstyledPlayer: FunctionComponent<PlayerProps> = (props) => {
  return (
    <div {...props} id="player">
      <div className="iframe-container">
        <iframe id="player_iframe" src="https://www.buzzsprout.com/2428722?client_source=large_player&iframe=true&referrer=https%3A%2F%2Fwww.buzzsprout.com%2F2428722%2Fpodcast%2Fembed" loading="lazy" width="75%" height="375" frameBorder="0" scrolling="no" title="Emmi & Annie Talk Indie"></iframe>
      </div>
    </div>
  );
};

const StyledPlayer = styled(UnstyledPlayer)`
  align-items: center;
  background-color: #AEAEFA;
  display: flex;
  justify-content: center;
  min-height: max(50vh, 50%);
  padding: 26px 0;

  @media screen and (min-width: 800px) {
    min-height: max(500px, 50%);
  }

  @media screen and (min-width: 800px) {
    min-height: max(500px, 50%);
    padding: 0;
  }

  .iframe-container {
    width: 85%;
    filter: drop-shadow(8px 8px 2px rgba(0, 0, 0, 0.2));

    iframe {
      width: 100%;
    }
  }
`;

export const Player: FunctionComponent<PlayerProps> = (props) => (
  <StyledPlayer {...props} />
);
